// Shared types/constants for OrgSettingsSection splits.

export type OrgSettings = {
  /** `organizations.name` — used to prefill branding/contact when unset. */
  organization_name: string;
  brand_name: string;
  logo_url: string;
  app_display_name: string;
  color_primary: string;
  color_secondary: string;
  tagline: string;
};

export const BLANK_ORG_SETTINGS: OrgSettings = {
  organization_name: "",
  brand_name: "",
  logo_url: "",
  app_display_name: "",
  color_primary: "",
  color_secondary: "",
  tagline: "",
};

export function applyOrgBrandCssVars(colors: {
  color_primary?: string;
  color_secondary?: string;
}): void {
  const root = document.documentElement;
  if (colors.color_primary) root.style.setProperty("--color-primary", colors.color_primary);
  else root.style.removeProperty("--color-primary");
  if (colors.color_secondary) root.style.setProperty("--color-secondary", colors.color_secondary);
  else root.style.removeProperty("--color-secondary");
}
